<template>
  <v-dialog
    v-model="isShow"
    :width="width+'px'">
    <div class="dialog-container">
      <div class="dialog-header">
        <span class="header-title">{{title}}</span>
        <font-awesome-icon
          icon="times"
          class="icon pointer"
          @click="handleCancel"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <slot></slot>
      </div>
      <div class="dialog-footer">
        <v-button
          gray
          @click="handleCancel">{{cancelText}}</v-button>
        <v-button
          green
          @click="handleSave">{{saveText}}</v-button>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'POPUP',
  props:{
    isShow:{
      type: Boolean,
      default: false
    },
    width:{
      type: [String, Number],
      default: 400,
    },
    title:{
      type: String,
      default: ''
    },
    cancelText:{
      type: String,
      default: 'Cancel'
    },
    saveText:{
      type: String,
      default: 'Save'
    },
  },
  methods: {
    handleCancel(){
      this.$emit('cancel')
    },
    handleSave(){
      this.$emit('save')
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    box-sizing: content-box;
    align-items: center;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    .header-title{
      font-weight: 600;
      font-size: 14px;
      color: #1B1F23;
    }
    .icon{
      color: #6A737D;
      font-weight: 900;
      font-size: 14px;
    }
  }
  .dialog-body{
    padding: 20px 15px 5px 15px;
  }
  .dialog-footer{
    padding: 15px;
    display: flex;
    justify-content: space-between;
  }
}
/deep/.el-dialog{
  border-radius: 6px;
}
</style>
